import React from 'react';
import { Link } from 'react-router-dom';
import { Home, Search, ReportProblem, ArrowBack } from '@mui/icons-material';

const NotFoundPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gradient-to-br from-gray-50 to-gray-100 flex items-center justify-center p-4" dir="rtl">
      <div className="max-w-2xl w-full text-center">
        
        {/* Error Number */}
        <div className="mb-8">
          <div className="relative inline-block">
            <div className="absolute inset-0 bg-gradient-to-r from-red-500 to-orange-500 rounded-full blur-2xl opacity-30"></div>
            <div className="relative">
              <span className="text-9xl font-black bg-gradient-to-r from-red-600 to-orange-600 bg-clip-text text-transparent">
                404
              </span>
            </div>
          </div>
        </div>

        {/* Error Message */}
        <div className="mb-10">
          <div className="inline-flex items-center justify-center gap-3 mb-4">
            <div className="p-3 bg-gradient-to-r from-red-100 to-orange-100 rounded-xl">
              <ReportProblem className="text-red-600 text-2xl" />
            </div>
            <h1 className="text-4xl font-bold text-gray-900">
              الصفحة غير موجودة
            </h1>
          </div>
          
          <p className="text-xl text-gray-600 mb-4">
            عذرًا، لم نتمكن من العثور على الصفحة التي تبحث عنها
          </p>
          <p className="text-gray-500 max-w-lg mx-auto">
            ربما تم نقل الصفحة أو حذفها، أو ربما أخطأت في كتابة العنوان.
          </p>
        </div>

        {/* Search Bar */}
        <div className="mb-10 max-w-md mx-auto">
          <div className="relative">
            <input
              type="text"
              placeholder="ابحث في الموقع..."
              className="w-full p-4 pl-14 rounded-xl border border-gray-300 focus:border-primary focus:ring-2 focus:ring-primary/20 transition-all duration-300 shadow-sm"
            />
            <div className="absolute right-4 top-1/2 transform -translate-y-1/2 text-gray-400">
              <Search />
            </div>
            <button className="absolute left-4 top-1/2 transform -translate-y-1/2 px-4 py-2 bg-gradient-to-r from-primary to-primary-dark text-white rounded-lg hover:opacity-90 transition-opacity duration-300">
              بحث
            </button>
          </div>
        </div>

        {/* Quick Actions */}
        <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-12">
          <Link
            to="/"
            className="flex flex-col items-center justify-center p-6 bg-white rounded-xl shadow-sm hover:shadow-lg transition-all duration-300 hover:scale-105"
          >
            <div className="p-4 bg-gradient-to-r from-primary/10 to-primary/20 rounded-lg mb-3">
              <Home className="text-primary text-2xl" />
            </div>
            <span className="font-semibold text-gray-900">الصفحة الرئيسية</span>
            <span className="text-sm text-gray-500 mt-1">العودة للرئيسية</span>
          </Link>

          <Link
            to="/products"
            className="flex flex-col items-center justify-center p-6 bg-white rounded-xl shadow-sm hover:shadow-lg transition-all duration-300 hover:scale-105"
          >
            <div className="p-4 bg-gradient-to-r from-green-100 to-emerald-100 rounded-lg mb-3">
              <Search className="text-green-600 text-2xl" />
            </div>
            <span className="font-semibold text-gray-900">تصفح المنتجات</span>
            <span className="text-sm text-gray-500 mt-1">اكتشف منتجاتنا</span>
          </Link>

          <Link
            to="/contact"
            className="flex flex-col items-center justify-center p-6 bg-white rounded-xl shadow-sm hover:shadow-lg transition-all duration-300 hover:scale-105"
          >
            <div className="p-4 bg-gradient-to-r from-blue-100 to-cyan-100 rounded-lg mb-3">
              <ArrowBack className="text-blue-600 text-2xl" />
            </div>
            <span className="font-semibold text-gray-900">اتصل بنا</span>
            <span className="text-sm text-gray-500 mt-1">نحن هنا لمساعدتك</span>
          </Link>
        </div>

        {/* Additional Links */}
        <div className="space-y-4">
          <p className="text-gray-500">أو جرب الروابط التالية:</p>
          <div className="flex flex-wrap justify-center gap-4">
            <Link to="/faq" className="text-primary hover:underline font-medium">
              الأسئلة الشائعة
            </Link>
            <Link to="/terms-conditions" className="text-primary hover:underline font-medium">
              شروط الاستخدام
            </Link>
            <Link to="/policies" className="text-primary hover:underline font-medium">
              سياسة الخصوصية
            </Link>
            <Link to="/about" className="text-primary hover:underline font-medium">
              من نحن
            </Link>
          </div>
        </div>

        {/* Technical Info */}
        <div className="mt-12 pt-8 border-t border-gray-200">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-gray-100 rounded-lg">
            <span className="text-sm text-gray-500">خطأ:</span>
            <code className="text-sm font-mono text-gray-700">404_NOT_FOUND</code>
          </div>
          <p className="text-xs text-gray-400 mt-4">
            إذا كنت تعتقد أن هذا خطأ من جانبنا، يرجى{" "}
            <a href="/contact" className="text-primary hover:underline">
              الإبلاغ عن المشكلة
            </a>
          </p>
        </div>

        {/* Brand Footer */}
        <div className="mt-8">
          <div className="inline-flex items-center gap-2">
            <div className="w-8 h-8 bg-gradient-to-r from-primary to-primary-dark rounded-lg"></div>
            <span className="font-bold text-gray-900">بازار ماركت بليس</span>
          </div>
          <p className="text-gray-500 text-sm mt-2">
            © {new Date().getFullYear()} | السوق الرقمي المصري
          </p>
        </div>
      </div>
    </div>
  );
};

export default NotFoundPage;